<template>
  <div class="w4m-streak">
    <Loading
      :active.sync="loading"
      :isFullPage="false"
      :z-index="500"
    ></Loading>
    <ul class="streak-list">
      <StreakElement
        v-for="(streakState, index) in streakStates"
        :key="getStateKey(streakState, index)"
        :backgroudColor="streakState.backgroudColor"
        :backgroundColor="streakState.backgroundColor"
        :textColor="streakState.textColor"
        :active="Boolean(streakState.active)"
        :title="streakState.title"
        :subtitle="streakState.subtitle"
        :counter="streakState.counter"
        :ariaLabel="getStateAriaLabel(streakState)"
        @click="changeActive(index)"
      />
    </ul>
  </div>
</template>
<script>
import StreakElement from "./W4MstreakElement.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "W4Mstreak",
  props: {
    states: {
      type: Array,
      default: () => [],
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    StreakElement,
    Loading,
  },
  watch: {
    states: {
      immediate: true,
      deep: true,
      handler(newStates) {
        this.syncStates(newStates);
      },
    },
    loader: {
      immediate: true,
      handler(newValue) {
        this.loading = Boolean(newValue);
      },
    },
  },
  data() {
    return {
      streakStates: [],
      activeIndex: -1,
      loading: false,
    };
  },
  methods: {
    syncStates(states) {
      const sourceStates = Array.isArray(states) ? states : [];
      let nextStates = sourceStates.map((state) => ({
        ...state,
        active: Boolean(state && state.active),
      }));

      const activeFromProps = nextStates.findIndex((state) => state.active);

      if (activeFromProps >= 0) {
        this.activeIndex = activeFromProps;
      } else if (this.activeIndex >= 0 && this.activeIndex < nextStates.length) {
        nextStates = nextStates.map((state, index) => ({
          ...state,
          active: index === this.activeIndex,
        }));
      } else {
        this.activeIndex = -1;
      }

      this.streakStates = nextStates;
    },
    getStateKey(state, index) {
      if (state && state.id !== undefined && state.id !== null) {
        return `state-id-${state.id}`;
      }
      if (state && state.title) {
        return `state-title-${state.title}-${index}`;
      }
      return `state-${index}`;
    },
    getStateAriaLabel(state) {
      const title = state && state.title ? state.title : "Estado";
      const counter =
        state && state.counter !== undefined && state.counter !== null
          ? state.counter
          : 0;
      const subtitle = state && state.subtitle ? `, ${state.subtitle}` : "";
      return `${title}: ${counter}${subtitle}`;
    },
    changeActive(index) {
      const currentState = this.streakStates[index];
      if (!currentState || currentState.active) {
        return;
      }
      this.activeIndex = index;
      this.streakStates = this.streakStates.map((state, stateIndex) => ({
        ...state,
        active: stateIndex === index,
      }));
      this.$emit("W4MStreakChangeSelected", {
        currentState: currentState.title,
        currentId: currentState.id ?? null,
        currentStateIndex: index,
      });
    },
  },
};
</script>
<style scoped>
.w4m-streak {
  position: relative;
  width: 100%;
  padding: 0.15rem 0 0.35rem;
}

.streak-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
  column-gap: 0.4rem;
  row-gap: 0.55rem;
}

@media screen and (max-width: 768px) {
  .streak-list {
    column-gap: 0.5rem;
    row-gap: 0.5rem;
    width: 100%;
  }
}
</style>
